"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.roundedSquare = void 0;

// source http://jsfiddle.net/highcharts/AxqKY/
// adding support for rounding corners to square shape
// actually generating svg path
var roundedSquare = function roundedSquare(x, y, w, h, options) {
  var arrowLength = 10,
      halfDistance = 7.5,
      r = options ? options.r : 4,
      anchorX = options && options.anchorX || x,
      anchorY = options && options.anchorY || y,
      top = ['M', x + r, y, 'L', x + w - r, y],
      topRight = ['C', x + w, y, x + w, y, x + w, y + r],
      right = ['L', x + w, y + h - r],
      rightBottom = ['C', x + w, y + h, x + w, y + h, x + w - r, y + h],
      bottom = ['L', x + r, y + h],
      bottomLeft = ['C', x, y + h, x, y + h, x, y + h - r],
      left = ['L', x, y + r],
      leftTop = ['C', x, y, x, y, x + r, y];

  if (anchorX > w) {
    right = ['L', x + w, anchorY - halfDistance, x + w + arrowLength, anchorY, x + w, anchorY + halfDistance, x + w, y + h - r];
  } else if (anchorX < 0) {
    left = ['L', x, anchorY + halfDistance, x - arrowLength, anchorY, x, anchorY - halfDistance, x, y + r];
  }

  return top.concat(topRight).concat(right).concat(rightBottom).concat(bottom).concat(bottomLeft).concat(left).concat(leftTop);
};

exports.roundedSquare = roundedSquare;